import { motion } from 'framer-motion'
import React, { useEffect, useRef, useState } from 'react'
import x from '../../assets/icons/close.svg'
import addPaymentType from '../../apis/addPaymentType'

const AddPaymentMethod = ({ refresh, active, close }) => {
  const popupref = useRef(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  // Single state object to store payment method details
  const [paymentData, setPaymentData] = useState({
    title: '',
    type: 'package', // Default to "package"
    type_name_en: '',
    type_name_ar: '',
    is_active: 1, // Default to active
  })

  // Function to handle input changes and update state dynamically
  const handleChange = (e) => {
    const { name, value } = e.target
    setPaymentData((prev) => ({
      ...prev,
      [name]: value || null, // Convert empty values to null
    }))
  }

  const handelAddCategory = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      await addPaymentType(paymentData)
      refresh()
      close()
    } catch (error) {
      setError('Error adding payment method')
      console.error('Error adding payment method:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [popupref, close])

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])

  return (
    <motion.div
      className="fixed inset-0 bg-overlay/30 w-screen z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className="w-1/3 min-h-10 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <form onSubmit={handelAddCategory} className="w-full">
          <div className="w-full px-8 py-5 flex flex-col gap-8">
            <div className="flex border-b-[1px] pb-4 justify-between border-b-darkBlue w-full">
              <div>Add New Payment Method</div>
              <img
                src={x}
                onClick={close}
                className="cursor-pointer"
                alt="Close"
              />
            </div>

            {/* Payment Name Input */}
            <div className="w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
              <input
                name="title"
                value={paymentData.title || ''}
                onChange={handleChange}
                className="w-full focus:outline-none"
                placeholder="Payment Name"
                required
              />
            </div>

            {/* Type Selection Dropdown */}
            <div className="w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
              <select
                name="type"
                value={paymentData.type}
                onChange={handleChange}
                className="w-full focus:outline-none bg-transparent"
                required
              >
                <option value="package">Package</option>
                <option value="balance">Balance</option>
              </select>
            </div>

            {/* Additional Fields */}
            {[
              { name: 'type_name_en', placeholder: 'Type Name (English)' },
              { name: 'type_name_ar', placeholder: 'Type Name (Arabic)' },
            ].map((field) => (
              <div
                key={field.name}
                className="w-full rounded-xl p-4 border-[1px] border-b-darkBlue"
              >
                <input
                  name={field.name}
                  value={paymentData[field.name] || ''}
                  onChange={handleChange}
                  className="w-full focus:outline-none"
                  placeholder={field.placeholder}
                />
              </div>
            ))}
          </div>
          {error && (
            <div className=" w-full flex justify-center py-3 items-center">
              <span className=" bg-red/20 px-3 py-1 text-red rounded">
                {error}
              </span>
            </div>
          )}

          <button
            disabled={loading}
            className="disabled:bg-darkBlue/50 bg-blueButton text-white text-center p-4 w-full"
          >
            {loading ? 'Adding...' : 'Add'}
          </button>
        </form>
      </motion.div>
    </motion.div>
  )
}

export default AddPaymentMethod
